export const AUTHORS_REDUCER_KEY = "AUTHORS";

export function reducer(state = [], action) {
    switch (action.type) {
        case "LOAD_AUTHORS_SUCCESS":
            return action.authors;
        default:
            return state;
    }
}